import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { TOMCAT_URL } from 'src/common';

class MultiLanguageDocumentUpload extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            stagedFiles: [],
            isUploading: false,
        };
    }

    handleFileSelection(e) {
        const fileList = e.target.files;
        if (!fileList || fileList.length === 0) return;
        this.setState({
            stagedFiles: Array.from(fileList),
        });
    }

    async handleUpload() {
        const { stagedFiles } = this.state;
        const { input, upload } = this.props;

        if (stagedFiles.length === 0 || !upload) return;

        this.setState({ isUploading: true });

        try {
            const action = await upload(stagedFiles);

            if (action && !action.error) {
                const rawInfo = action.payload;
                if (rawInfo && rawInfo[0]) {
                    input.onChange(rawInfo[0]);
                    this.setState({ stagedFiles: [] });
                    if (this.fileInput) this.fileInput.value = '';
                }
            }
        } catch (error) {
            console.error('Upload failed:', error);
        } finally {
            this.setState({ isUploading: false });
        }
    }

    handleDelete() {
        this.props.input.onChange(null);
        this.setState({ stagedFiles: [] });
    }

    render() {
        const { input, disabled, t } = this.props;
        const { stagedFiles, isUploading } = this.state;

        const fileData = input.value;
        const hasFile = fileData && (fileData.name || fileData.path);
        const isDisabled = disabled || (input && input.disabled);
        return (
            <div className="multi-language-upload-container">
                {hasFile ? (
                    <div
                        className="uploaded-file-row"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            background: '#f9f9f9',
                        }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <i className="fa fa-file-text-o" style={{ marginRight: '10px', color: '#555' }} />
                            <span style={{ fontWeight: '500', fontSize: '10px' }}>
                                <a
                                    href={`${TOMCAT_URL}public/documents/${fileData.filename}`}
                                    target="_blank"
                                    rel="noreferrer">
                                    {' '}
                                    {fileData.filename}
                                </a>
                            </span>
                        </div>

                        <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={this.handleDelete}
                            disabled={isDisabled}>
                            <i className="fa fa-trash" style={{ marginRight: '5px' }} />
                            {t('modules_store.documents.delete')}
                        </button>
                    </div>
                ) : (
                    <div className="upload-action-row" style={{ display: 'flex', gap: '10px' }}>
                        <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
                            <input
                                type="file"
                                className="form-control"
                                ref={el => (this.fileInput = el)}
                                disabled={isDisabled || isUploading}
                                onChange={this.handleFileSelection}
                            />
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleUpload}
                            disabled={isUploading || stagedFiles.length === 0}
                            style={{ whiteSpace: 'nowrap' }}>
                            {isUploading ? (
                                <>
                                    <i className="fa fa-circle-o-notch fa-spin" />{' '}
                                    {t('modules_store.documents.uploading')}
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-upload" /> {t('modules_store.documents.add')}
                                </>
                            )}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default connect(null, {})(MultiLanguageDocumentUpload);
